import React,{useState,useEffect} from "react";
import { BrowserRouter as Router, Route, Routes,useLocation } from "react-router-dom";
import Tree from "tree/tree";
import Transaction from "transaction/transaction";
import {minYear,backEndGeneo,client} from './tree/treeProvider'
import {Langue} from './context'
//import {Langue} from 'context'

export default function App() {
    const [minimumYear,setMinimumYear]=useState(0)
    const [backEnd,setBackEnd]=useState("")
    const [waiting,setWaiting]=useState(true)
    const [clientGeneo,setClientGeneo]=useState("")

    


    async function init()
  {
   // setTimeout(async function(){
      try{
        
       
      

        //const config:projectTypes.config = await $.getJSON(prot+window.location.hostname+"/config.json");
      
        
     
        let root = document.getElementById("root");
        if(root!==null)
        {
          root.classList.remove("mainReact");
          root.classList.add("root");
        }

        let loading=document.getElementById("loading")
        if(loading!==null)
          loading.style.display="none";
        
     
    
      }catch(error)
      {
        console.error(error);
        debugger
      }
  //  },20000)
  }

  useEffect(function(){
    init()
  },[])

    async function loadConfig()
    {
        try{
            const res = await fetch("/config.json");
            
            if (!res.ok) {
                debugger
                throw new Error("Failed to load config");
            }
            
            const {geneoMinYear,backEndGeneo,clientGeneo}= await res.json();
            setMinimumYear( geneoMinYear)
            setBackEnd(backEndGeneo)
            setClientGeneo(clientGeneo)
            setWaiting(false)
        }catch(error)
        {
            console.log(error)
            debugger;
            throw error
        }
    }

    useEffect(function(){
        loadConfig()
    },[])
   



   return (<>
            {waiting?
            <div>
                Waiting
            </div>:
            <backEndGeneo.Provider value={backEnd}>
                
                <minYear.Provider value={minimumYear}>
                    <client.Provider value={clientGeneo}>
                        <Router>
                        
                                <Routes>
                                    <Route path={clientGeneo} element={<Tree />} />
                                    <Route path={clientGeneo+"transaction/:transaction"} element={<Transaction />} />
                                </Routes>
                           
                        </Router>
                    </client.Provider>
                </minYear.Provider>
                
            </backEndGeneo.Provider>
            }
        </>
  
  );
}